/* eslint-disable */
import { useContext, useState } from "react";

import { useLocation, useNavigate } from "react-router-dom";

import {
  FileSearch,
  HamburgerMenu,
  Insurance,
  LogoutIcon,
  ReceiptOutline,
  UserIcon,
} from "../../common/icons";
import SideMenu, { MenuItem } from "./SideMenu";
import { LocalizationContext } from "../../App";
import { useAppDispatch, useAppSelector } from "../../store/store";
import { logout } from "../../store/authSlice";

type HeaderProps = {
  showMenuIcon?: boolean;
};

const Header = ({ showMenuIcon = true }: HeaderProps) => {
  const l10n = useContext(LocalizationContext);
  const { state } = useLocation();
  const { disableNavigation } = state || { disableNavigation: false };
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const location = useLocation();
  const isUserLogged = useAppSelector((state) => state.auth.isUserLogged);
  const [showMenu, setShowMenu] = useState(0);

  const changeRoute = (route: string) => {
    navigate(route);
    if (showMenu > 0) setShowMenu(0);
  };

  function logoutUser(): void {
    dispatch(logout());
    navigate("/");
    if (showMenu > 0) setShowMenu(0);
  }

  const menuItems: MenuItem[] = [
    {
      icon: <LogoutIcon className="side-menu-item-icon" />,
      onClick: (_) => changeRoute("/login"),
      title: l10n.menu.login,
      isVisible: !isUserLogged,
    },
    {
      icon: <UserIcon className="side-menu-item-icon" />,
      onClick: (_) => changeRoute("/profile"),
      title: l10n.menu.profile,
      isVisible: isUserLogged,
    },
    {
      icon: <Insurance className="side-menu-item-icon w-7 h-7" />,
      onClick: (_) => changeRoute("/insurance"),
      title: l10n.menu.insurance,
      isVisible: isUserLogged,
    },
    {
      icon: <ReceiptOutline className="side-menu-item-icon" />,
      onClick: (_) => changeRoute("/insurance/installments"),
      title: l10n.menu.invoices,
      isVisible: isUserLogged,
    },
    {
      icon: <FileSearch className="side-menu-item-icon" />,
      onClick: (_) => changeRoute("/claim"),
      title: l10n.menu.claim,
      isVisible: isUserLogged,
    },
    {
      // TODO: 5. Logout to replace brand select
      icon: <LogoutIcon className="side-menu-item-icon" />,
      onClick: (_) => logoutUser(),
      title: l10n.menu.logout,
      isVisible: isUserLogged,
    },
  ];

  return (
    <>
      <nav className="navbar">
        <div className="h-navbar flex justify-center">
          <div className="w-full max-w-[800px] h-navbar flex items-center">
            <div className="w-full inline-flex justify-between items-center">
              <div className="navbar-item-wrapper navbar-logo-wrapper">
                <div
                  className="navbar-logo"
                  onClick={() => {
                    if (!disableNavigation && location.pathname !== "/") {
                      changeRoute("/");
                    }
                  }}
                />
              </div>
              {!disableNavigation && showMenuIcon && (
                <div
                  className="navbar-item-wrapper side-menu-toggle-wrapper"
                  onClick={() => setShowMenu(Math.random())}
                >
                  <HamburgerMenu className="side-menu-toggle" />
                </div>
              )}
            </div>
          </div>
        </div>
      </nav>
      <SideMenu displayMenu={showMenu} menuItems={menuItems} />
    </>
  );
};

export default Header;
